/* src/students/cards/TutorCard/styles.js */

export default theme => ({
  card: {
    height: theme.spacing.unit * 90,
    overflowY: 'auto',
    position: 'relative',
  },
  generalInfo: {
    display: 'flex',
    flexDirection: 'row',
  },
  expand: {
    transform: 'rotate(0deg)',
    transition: theme.transitions.create('transform', {
      duration: theme.transitions.duration.shortest,
    }),
    marginLeft: 'auto',
  },
  expandOpen: {
    transform: 'rotate(180deg)',
  },
  footerStyle: {
    display: 'flex',
    justifyContent: 'flex-end',
  },
  moreInfo: {
    display: 'flex',
    flexGrow: 1,
    padding: theme.spacing.unit,
  },
});



// WEBPACK FOOTER //
// ./src/modules/tutors/cards/TutorCard/styles.js